import CommonModal from 'components/common/CommonModal';
import DefaultButton from 'components/common/DefaultButton';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import LabelInput from 'components/common/LabelInput';
import {changeContractorName} from 'function/api';
import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {userInfoState} from 'utils/Atoms';
import {minmax} from 'utils/minmax';

type Props = {
  selectItem: any;
  closeModal: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorModal: React.Dispatch<React.SetStateAction<{}>>;
};

const ChangeContractorNameModal = ({
  selectItem,
  closeModal,
  setIsLoading,
  setErrorModal,
}: Props) => {
  const userInfo = useRecoilValue(userInfoState);
  const [name, setName] = useState<string>('');
  const [confirmModal, setConfirmModal] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);

  useEffect(() => {
    if (selectItem) {
      setName(selectItem?.name || '');
    }
  }, [selectItem]);

  return (
    <>
      <CommonModal closeModal={closeModal}>
        <ModalContainer>
          <ModalHeader>
            <DefaultText
              text="시공사명 변경"
              textStyle={{fontSize: minmax(40)}}
            />
            <DefaultImageView
              source="images/common/close.png"
              onClick={closeModal}
              style={{
                width: minmax(30),
                height: minmax(30),
                margin: minmax(15),
                cursor: 'pointer',
              }}
            />
          </ModalHeader>

          <InfoRow>
            <DefaultText
              text={`UUID: ${selectItem?.uuid || ''}`}
              textStyle={{fontSize: minmax(20), color: colors.darkGray}}
            />
          </InfoRow>

          <LabelInput
            type={'text'}
            labelText={'시공사명'}
            value={name}
            setValue={setName}
          />

          <DefaultButton
            text="change"
            actived={1}
            buttonStyle={{
              width: '100%',
              backgroundColor: colors.primary2,
            }}
            textStyle={{fontSize: minmax(25)}}
            onClick={() => {
              if (!name || !name.trim()) {
                setErrorModal({title: '입력 오류', detail: '시공사명을 입력해주세요.'});
                return;
              }
              setConfirmModal(true);
            }}
          />
        </ModalContainer>
      </CommonModal>
      {confirmModal && (
        <CommonModal
          title="시공사명 변경 확인"
          detail={`시공사명을 "${name.trim()}"(으)로 변경하시겠습니까?\n\n※ 위험성평가/안전교육/공지 등 대부분의 문서는 자동 동기화됩니다. 다만 일부 법정 문서에서 구버전 이름이 잔존할 수 있습니다.`}
          firstButtonText="confirm"
          secondButtonText="cancel"
          firstButtonClick={async () => {
            setConfirmModal(false);
            const result = await changeContractorName({
              userInfo,
              setIsLoading,
              setErrorModal,
              contractorUUID: selectItem?.uuid,
              name: name.trim(),
            });
            if (result) setCompleteModal(true);
          }}
          secondButtonClick={() => setConfirmModal(false)}
          closeModal={() => setConfirmModal(false)}
        />
      )}
      {completeModal && (
        <CommonModal
          title="시공사명 변경 완료!"
          detail="시공사명이 변경되었습니다. 관련 문서도 자동 동기화되었습니다."
          firstButtonText="confirm"
          firstButtonClick={() => {
            closeModal();
            window.location.reload();
          }}
        />
      )}
    </>
  );
};

export default ChangeContractorNameModal;

const ModalContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${minmax(20)};
`;

const ModalHeader = styled.div`
  width: 100%;
  margin-bottom: ${minmax(10)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

const InfoRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
